export default "__VITE_ASSET__DXq1a9YI__"